import {createBrowserRouter, Navigate, Outlet} from 'react-router-dom';
import {APP_PATHS} from './constants';
import {Capacitor} from '@capacitor/core';
import ScrollToTop from './components/scroll-to-top';
import BackButtonHandler from './components/native-back-button';
import { FirebaseScreenViewTracker } from './helpers/firebase-analytics-tracker';
import React, { Suspense, lazy } from 'react';
// Always (non lazy) load of frequent used pages
import LoadingPage from './pages/loading-page';
import HomePage from './pages/home';
import NativeHomePage from './pages/native-home/index';
import Login from './pages/login';
import SignUp from './pages/sign-up';
import PrivateRoute from './components/private-route/private-route';
import RouteContextOfferWrapper from './providers/offers-context/route-context-offer-wrapper';
import Offers from './pages/offers';
import Offer from './pages/offer';
import Cashout from './pages/cashout';
import ProfilePage from './pages/profile';
import Surveys from './pages/surveys';
// Lazy load other pages to improve initial load time
const NotFound = lazy(() => import('./pages/not-found'));
const AboutUS = lazy(() => import('./pages/about-us'));
const Privacy = lazy(() => import('./pages/privacy-policy'));
const Terms = lazy(() => import('./pages/terms-of-service'));
const ContactUs = lazy(() => import('./pages/contact-us'));
const ConfirmEmail = lazy(() => import('./pages/confirm-email'));
const ResetPassword = lazy(() => import('./pages/reset-password'));
const VerifyEmail = lazy(() => import('./pages/verify-email'));


// Create browser routing
export const router = createBrowserRouter([
  {
    path: '/',
    element:  (
      <>
        <BackButtonHandler />{/* Handle back button click on native platforms */}
        <ScrollToTop /> {/* Scroll page to top on route change */}
        <FirebaseScreenViewTracker /> {/* Fire 'screen_view' event on route change to firebase */}
        <Suspense fallback={<LoadingPage />}>
          <Outlet /> {/* Render the page content */}
        </Suspense>
      </>
    ),
    children: [
      {
        path: APP_PATHS.BASE,
        element: Capacitor.isNativePlatform() ? <NativeHomePage /> : <HomePage />
      },
      {
        path: APP_PATHS.ERROR,
        element: <NotFound />
      },
      {
        path: APP_PATHS.EMAIL_CONFIRMATION,
        element: <ConfirmEmail />
      },
      {
        path: APP_PATHS.LOGIN,
        element: <Login />
      },
      {
        path: APP_PATHS.SIGN_UP,
        element: <SignUp />
      },
      {
        path: APP_PATHS.RESET_PASSWORD,
        element: <ResetPassword />
      },
      {
        path: APP_PATHS.VERIFY_EMAIL,
        element: <VerifyEmail />
      },
      {
        path:APP_PATHS.ABOUT_US,
        element: <AboutUS />
      },
      {
        path: APP_PATHS.PRIVACY,
        element: <Privacy />
      },
      {
        path: APP_PATHS.TERMS,
        element: <Terms />
      },
      {
        path: APP_PATHS.CONTACT_US,
        element: <ContactUs />
      },
      {
        path: APP_PATHS.PROFILE,
        element: (
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        )
      },
      {
        path: APP_PATHS.CASHOUT,
        element: (
          <PrivateRoute>
            <Cashout />
          </PrivateRoute>
        )
      },
      {
        path: APP_PATHS.SURVEYS,
        element: (
          <PrivateRoute>
            <Surveys />
          </PrivateRoute>
        )
      },
      {
        element: (
          <PrivateRoute>
            <RouteContextOfferWrapper />
          </PrivateRoute>
        ),
        children: [
          {
            path: APP_PATHS.OFFERS,
            element: <Offers />
          },
          {
            path: `${APP_PATHS.OFFER}/:offerId`,
            element: <Offer />
          }
        ]
      },
      {
        path: '*',
        element: <Navigate to={APP_PATHS.ERROR} replace />
      }
    ]
  }
]);
